import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useToastError } from "@/components/ui/use-toast";
import { useApi } from "@/hooks/useApi";
import { useTranslation } from "@/hooks/useTranslation";
import { AdminTeamDTO, AdminTeamUserDTO } from "@shaarp/common";
import { useEffect, useState } from "react";
import DataTableAdminTeamUsers from "../data-table-team-users/data-table-admin-team-users";
import { DialogHeader } from "../ui/dialog";

export const DialogAdminTeamUsers = ({
  team,
  open,
  onClose,
}: {
  team: AdminTeamDTO;
  open: boolean;
  onClose: () => void;
}) => {
  const toastError = useToastError();
  const api = useApi();
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<AdminTeamUserDTO[]>([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      const { data } = await api.get<AdminTeamUserDTO[]>(
        `/admin/team/${team.id}/users`
      );
      setUsers(data);
    } catch (e) {
      toastError();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent className="sm:max-w-[1000px]">
        <DialogHeader>
          <DialogTitle>
            {t("admin.dataTableAdminTeams.dialogs.users.title", {
              teamName: team.name,
            })}
          </DialogTitle>
        </DialogHeader>
        <div className="py-3 space-y-5 border-t">
          <DataTableAdminTeamUsers users={users} isLoading={isLoading} />
        </div>
      </DialogContent>
    </Dialog>
  );
};
